<template lang="html">

  <article class="evento-el" :style="`background: url(${data.ulrImagenPrincipal}) center/cover no-repeat`" :destacado="data.destacado" :caducado="caducado">

    <div class="contenedor-texto column-start">
      
      <nav class="tags row-between">
        
        <span class="categoria -white" to="">{{data.categoria}}</span>

        <img src="/static/img/icons/evento-destacado.svg" alt="Evento destacado" v-if="data.destacado">
  
      </nav>

      <h2 class="title-dato -white" v-html="data.titulo"></h2>

      
    </div>
    
    <div class="info row-start">
      <p class="-fecha -white">{{data.fecha | fecha}}</p>
      <p class="-lugar -white">{{data.lugar}}</p>
    </div>

    <router-link :to="$t('enlaces.eventos')+'/'+data.urlAcceso" class="enlace-cover"></router-link>

  </article>

</template>

<script lang="js">
  export default  {
    name: 'evento-el',
    props :['data'],
    computed : {
      caducado(){
        let actual = new Date().getTime();
        let date = new Date(this.data.fecha).getTime();

        return (date<actual);

      }
    },
    filters: {
      fecha(value) {
        let date = new Date(value);

        return `${date.getDate()}/${date.getMonth()+1}/${date.getFullYear()}`

      }
    }
  }
</script>

<style scoped lang="scss">


</style>



// WEBPACK FOOTER //
// submodules/dotia-base-fp/src/components/views/eventos/evento-el.vue